<template>
    <b-modal title="Classification Documents" :id="'classification-documents-view-' + id" :no-close-on-backdrop="true"
        size="lg" :hide-footer="true" centered>
        <b-row>
            <b-col lg="6" md="6" sm="12">
                <b-form-group label="Supporting Documents" label-for="Supporting Documents"
                    label-class="font-weight-bold pt-0" />

                <div v-show="documents && documents.length > 0">
                    <b-list-group>
                        <b-list-group-item v-for="(document, index) in documents" :key="index" class="border-0 p-0">
                            <b-form-group :label="'Document ' + (index + 1)" :label-for="'Document ' + (index + 1)"
                                label-class="mb-0">
                                <b-link :id="'Document ' + (index + 1)" href="#"
                                    @click.prevent="onShowDocument(document)">
                                    {{ document.name }}
                                </b-link>
                            </b-form-group>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-col>

            <b-col lg="6" md="6" sm="12">
                <b-form-group label="Remarks" label-for="Remarks" description label-class="font-weight-bold pt-0">
                    <label v-if="classification.remarks" id="Remarks">
                        {{ classification.remarks }}
                    </label>
                </b-form-group>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
// Others
import EventBus from '@/shared/event-bus';
import _ from 'lodash';

export default {
    name: 'classification-documents-view',
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            classification: {}
        }
    },
    computed: {
        documents() {
            return _.compact(this.classification.documents) || [];
        }
    },
    mounted() {
        EventBus.$on('onUpdateClassificationDocumentsView', classification => {
            console.log(classification);
            this.classification = classification;
        });
    },
    methods: {
        onShowDocument(doc) {
            let url = doc.url;
            let fileName = doc.name;

            EventBus.$emit("onSelectImageView", { url: url, name: fileName });
            this.$bvModal.show("image-view-dialog");
        }
    },
    beforeDestroy() {
        EventBus.$off('onUpdateClassificationDocumentsView');
    }
}
</script>

<style scoped>
.list-group-item {
    border: 0 !important;
}
</style>